export default {
    clamp(value,min,max){
        if(value < min) return min;
        if(value > max) return max;
        return value;
    },
    ratio(value,ratio){
        return value /= ratio;
    },
    format(value,min,max,ratio){
        value = this.clamp(value,min,max);
        value = this.ratio(value,ratio);
        return Math.floor(value);
    },
    clone(obj){
        return JSON.parse(JSON.stringify(obj))
    },
    localStorage(key,value){
    
        if(typeof value === "undefined") {
            if (!localStorage[key])
                return false;
    
            return JSON.parse(localStorage[key])
        }
        
        localStorage[key] = JSON.stringify(value);
    },
    sizeToString(size){
    
        if(size === 0) return "";
    
        let o = size;
        if(o < 1024) return o+" o";
    
        let ko = Math.round(o / 1024);
        if(ko < 1024) return ko+" Ko";
    
        let mo = Math.round(ko / 1024);
        if(mo < 1024) return mo.toFixed(2)+" Mo";
    
        let go = Math.round(mo / 1024);
        if(go < 1024) return go.toFixed(2)+" Go";
    },
    removeAccents(s)
    {
        let i = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž'.split('');
        let o = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz'.split('');
        let map = {};
        i.forEach(function(el, idx) {map[el] = o[idx]});
        return s.replace(/[^A-Za-z0-9]/g, function(ch) { return map[ch] || ch; }).toLowerCase();
    },
}